import React, { useMemo } from 'react';
import { Button, Grid, Flag, SelectPopover } from '@planne-software/uni';
import { IconCheck } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';
import useBreakpoint from '@src/hooks/useBreakpoint';

import { POPOVER_WIDTH } from '../TariffSelector/constants';
import { SequentialSlotShell } from '../SequentialSlotShell';
import { useLanguageSelector } from '../../hooks/useLanguageSelector';
import { useGuardedSequentialOpenChange } from '../../hooks/useGuardedSequentialOpenChange';
import { LanguageOptionButton, TriggerLabel, TriggerValue } from './styles';

const LanguageSelector = () => {
  const { i18n } = useTranslate();
  const { isMobile } = useBreakpoint();
  const state = useLanguageSelector();

  const guardedOnOpenChange = useGuardedSequentialOpenChange('language', state.onOpenChange);

  const selectedElement = useMemo(
    () =>
      state.selectedLabel ? (
        <TriggerValue>
          <TriggerLabel>{state.selectedLabel}</TriggerLabel>
        </TriggerValue>
      ) : undefined,
    [state.selectedLabel, state.selectedOption],
  );

  if (!state.visible) {
    return null;
  }

  return (
    <SequentialSlotShell slot='language'>
      <SelectPopover
        name='product-booking-language'
        id='product-booking-language'
        fullWidth
        size='sm'
        placeholder={i18n('product_booking_language_placeholder')}
        selectedElement={selectedElement}
        disabled={state.loading || state.isAddingToCart}
        disablePopover={state.isAddingToCart}
        open={state.open}
        onOpenChange={guardedOnOpenChange}
        isBottomSheet
        bottomSheetTitle={i18n('product_booking_language_placeholder')}
        popoverWidth={isMobile ? undefined : POPOVER_WIDTH}
        footer={
          <Button
            fullWidth
            color='primary'
            variant='contained'
            startSlot={<IconCheck size={20} />}
            disabled={state.disableConfirm}
            onClick={state.onConfirm}
          >
            {i18n('base_confirm')}
          </Button>
        }
      >
        <Grid container spacing={3} padding={{ xs: 4, md: 6 }} aria-label='language-options'>
          {state.options.map((option) => {
            const selected = state.value === option.value;

            return (
              <Grid size={6} key={option.value}>
                <LanguageOptionButton
                  fullWidth
                  variant='outlined'
                  color='neutral'
                  data-selected={selected}
                  disabled={state.isAddingToCart}
                  onClick={() => state.onSelect(option.value)}
                  startSlot={<Flag code={option.flagCode ?? ''} size={20} aria-hidden />}
                >
                  {option.label}
                </LanguageOptionButton>
              </Grid>
            );
          })}
        </Grid>
      </SelectPopover>
    </SequentialSlotShell>
  );
};

export default LanguageSelector;
